import PropTypes from 'prop-types'
import * as actions from 'services/viewport/actions'
import { Component } from 'react'
import { connect } from 'react-redux'
import { selectViewport } from 'services/viewport/selectors'
import isServer from 'shared/isServer'

const mapDispatchToActions = {
  ...actions,
}

const mapStateToProps = state => ({
  viewport: selectViewport(state),
})

export class ResponsiveContainer extends Component {

  static propTypes = {
    store: PropTypes.object,
    location: PropTypes.string,
    history: PropTypes.object,
    selectViewport: PropTypes.func,
    updateViewport: PropTypes.func,
  }

  constructor (props) {
    super(props)

    if (!isServer()) {
      this.state = {
        height: window.innerHeight,
        width: window.innerWidth,
      }
    }
    this.updateDimensions = this.updateDimensions.bind(this)
  }

  componentWillMount () {
    if (!isServer()) {
      window.addEventListener('resize', this.updateDimensions)
    }
  }

  componentWillUnmount () {
    if (!isServer()) {
      window.removeEventListener('resize', this.updateDimensions)
    }
  }

  updateDimensions () {
    this.setState({
      height: window.innerHeight,
      width: window.innerWidth,
    })

    this.props.updateViewport(this.state.width)
  }

  render () { return null }

}

export default connect(mapStateToProps, mapDispatchToActions)(ResponsiveContainer)
